<template>
    <div class="row align-items-end">
        <div class="col-md-2 mb-1 mb-md-0">
            <label class="form-label">İzin Türü</label>
            <v-select-list :options="types" label="Name" v-model="type" placeholder="Tümü"></v-select-list>
        </div>
        <div class="col-auto">
            <button class="btn btn-secondary" v-on:click="$emit('filter',filterData)">Filtrele</button>
        </div>
        <div class="col-auto">
            <button class="btn btn-dark" v-on:click="clearForm">Temizle</button>
        </div>
    </div>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'

export default {
    data(){
        return{
            types:[],
            filterData:{
                EmployeeExcuseTypeId:null
            }
        }
    },
    mounted(){
        this.getTypes()
    },
    methods:{
        clearForm(){
            this.filterData.EmployeeExcuseTypeId = null
            this.$emit('filter',this.filterData)
        },
        getTypes(){
            EmployeeOperationsApi.ExcuseType.List().then(res=>{
                this.types = res.data.Data
            })
        },
    },
    computed:{
        type:{
            get:function(){
                return this.types.find(b=>b.Id==this.filterData.EmployeeExcuseTypeId)
            },
            set:function(value){
                this.filterData.EmployeeExcuseTypeId = value?.Id || null
            }
        }
    }
}
</script>